import React, { useState, useEffect } from 'react';

const SuperAdminSearchHistory = () => {
  const [searchHistories, setSearchHistories] = useState([]);
  const [editSearchHistoryForm, setEditSearchHistoryForm] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchSearchHistories = async () => {
      if (!token) {
        setError('No authentication token found. Please log in.');
        return;
      }
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await response.json();
        if (response.ok) {
          setSearchHistories(data.searchHistories || []);
        } else {
          setError(data.message || 'Failed to fetch search histories');
        }
      } catch (err) {
        setError('Server error while fetching search histories');
      }
    };

    fetchSearchHistories();
  }, [token]);

  const handleEditSearchHistory = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}admin/superadmin/edit-search-history/${editSearchHistoryForm._id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ reason: editSearchHistoryForm.reason })
        }
      );
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        setEditSearchHistoryForm(null);
        const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const activitiesData = await activitiesResponse.json();
        if (activitiesResponse.ok) {
          setSearchHistories(activitiesData.searchHistories || []);
        }
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError('Server error while editing search history');
    }
  };

  return (
    <div className="p-6 bg-white text-gray-800">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">All Admin Search Histories</h2>
      {error && <p className="mb-4 text-red-600">{error}</p>}
      {success && <p className="mb-4 text-green-600">{success}</p>}

      {editSearchHistoryForm && (
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Edit Search History</h3>
          <form onSubmit={handleEditSearchHistory} className="bg-gray-100 p-6 rounded-lg shadow-md">
            <div className="mb-4">
              <input
                type="text"
                placeholder="Reason"
                value={editSearchHistoryForm.reason || ''}
                onChange={(e) => setEditSearchHistoryForm({ ...editSearchHistoryForm, reason: e.target.value })}
                className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500 w-full"
              />
            </div>
            <button
              type="submit"
              className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition-colors"
            >
              Save Changes
            </button>
            <button
              type="button"
              onClick={() => setEditSearchHistoryForm(null)}
              className="ml-2 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2 text-left text-gray-700">Admin</th>
              <th className="p-2 text-left text-gray-700">JobSeeker Email</th>
              <th className="p-2 text-left text-gray-700">JobSeeker Name</th>
              <th className="p-2 text-left text-gray-700">Own JobSeeker</th>
              <th className="p-2 text-left text-gray-700">Reason</th>
              <th className="p-2 text-left text-gray-700">Searched At</th>
              <th className="p-2 text-left text-gray-700">Actions</th>
            </tr>
          </thead>
          <tbody>
            {searchHistories?.map(search => (
              <tr
                key={search._id}
                className={`border-b border-gray-200 ${search.isOwnJobSeeker ? '' : 'bg-red-100'}`}
              >
                <td className="p-2">{search.adminId?.fullName} ({search.adminId?.email})</td>
                <td className="p-2">{search.jobSeekerEmail}</td>
                <td className="p-2">{search.jobSeekerId ? `${search.jobSeekerId.firstName} ${search.jobSeekerId.lastName}` : '-'}</td>
                <td className="p-2">{search.isOwnJobSeeker ? 'Yes' : 'No'}</td>
                <td className="p-2">{search.reason || '-'}</td>
                <td className="p-2">{new Date(search.searchedAt).toLocaleDateString()}</td>
                <td className="p-2">
                  <button
                    onClick={() =>
                      setEditSearchHistoryForm({
                        _id: search._id,
                        reason: search.reason
                      })
                    }
                    className="bg-orange-500 text-white px-2 py-1 rounded hover:bg-orange-600"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {searchHistories?.length === 0 && (
          <p className="text-gray-600 mt-2">No search histories found.</p>
        )}
      </div>
    </div>
  );
};

export default SuperAdminSearchHistory;